import { render, staticRenderFns } from "./ban.vue?vue&type=template&id=f353941a&scoped=true&"
var script = {}
import style0 from "./ban.vue?vue&type=style&index=0&id=f353941a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f353941a",
  null
  
)

export default component.exports